import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/du3yfcfm_logoo.png" 
              alt="CLND Logo" 
              className="h-10 mb-4"
            />
            <p className="text-sm mb-4">
              CLND Menkul Değerler A.Ş. - Yeni nesil yatırım platformu
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hızlı Erişim</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-teal-400 transition-colors">Ana Sayfa</Link></li>
              <li><Link to="/hakkimizda" className="hover:text-teal-400 transition-colors">Hakkımızda</Link></li>
              <li><Link to="/hizmetler" className="hover:text-teal-400 transition-colors">Hizmetler</Link></li>
              <li><Link to="/iletisim" className="hover:text-teal-400 transition-colors">İletişim</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hizmetlerimiz</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/hizmetler/viop-islemleri" className="hover:text-teal-400 transition-colors">VİOP İşlemleri</Link></li>
              <li><Link to="/hizmetler/pay-alim-satim" className="hover:text-teal-400 transition-colors">Pay Alım-Satım</Link></li>
              <li><Link to="/hizmetler/yatirim-fonlari" className="hover:text-teal-400 transition-colors">Yatırım Fonları</Link></li>
              <li><Link to="/hizmetler/yatirim-danismanligi" className="hover:text-teal-400 transition-colors">Yatırım Danışmanlığı</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">İletişim</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center space-x-2">
                <Mail size={16} className="flex-shrink-0" />
                <span>destek@clndonlinesube.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2026 CLND Menkul Değerler A.Ş. Tüm hakları saklıdır.
            </p>
            <div className="flex space-x-4 text-sm">
              <Link to="/gizlilik" className="hover:text-teal-400 transition-colors">Gizlilik Politikası</Link>
              <Link to="/kvkk" className="hover:text-teal-400 transition-colors">KVKK</Link>
              <Link to="/cerez" className="hover:text-teal-400 transition-colors">Çerez Politikası</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;